import { render, staticRenderFns } from "./PreferencesHeightPage.vue?vue&type=template&id=058cbd3a"
import script from "./PreferencesHeightPage.vue?vue&type=script&lang=js"
export * from "./PreferencesHeightPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports